export { default } from './social-icon'
